import api from './api';

export const getSaasPlans = () => api.get('/saas');

export const giveSaasForFree = (saasIds, channelUid) => api.post(`admin/saasPlans/give`, { saasIds, channelUid });

export const getPlanUsages = channelUid => {
  return api.get(`/admin/channel/${channelUid}/usages`);
};

export const getPlans = channelUid => {
  return api.get(`/admin/channel/${channelUid}/plans`);
};
